import React from "react";
import {
  FaEnvelope,
  FaPhoneAlt,
  FaHeadset,
  FaWhatsapp,
  FaClipboardList,
  FaClock,
} from "react-icons/fa";
import { Link } from "react-router-dom";
import "./SupportComplaints.css";

export default function SupportComplaints() {
  const whatsappMessage = encodeURIComponent(
    "مرحبًا، أريد تقديم استفسار أو شكوى بخصوص خدمات التنظيم للسفر والسياحة"
  );

  return (
    <main className="support-complaints-page" dir="rtl">
      <section className="support-hero">
        <div className="container">
          <h1>الدعم والشكاوى</h1>
          <p>
            خدمة العملاء والشكاوى متاحة على مدار الساعة طوال أيام الأسبوع للرد
            على الاستفسارات والشكاوى المتعلقة بخدمات التنظيم للسفر والسياحة.
          </p>
        </div>
      </section>

      <section className="container support-content support-content-single">
        <div className="support-info-card support-main-card">
          <h2>
            <FaHeadset /> قنوات التواصل الرسمية
          </h2>

          <div className="support-grid">
            <div className="support-channel-card">
              <FaPhoneAlt />
              <h3>الهاتف الموحد</h3>
              <a href="tel:920033239">920-0332-39</a>
            </div>

            <div className="support-channel-card">
              <FaWhatsapp />
              <h3>واتساب 24/7</h3>
              <a
                href={`https://wa.me/966920033239?text=${whatsappMessage}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                تواصل عبر واتساب
              </a>
            </div>

            <div className="support-channel-card">
              <FaEnvelope />
              <h3>البريد الإلكتروني</h3>
              <a href="mailto:info@tnzeem.com">info@tnzeem.com</a>
            </div>

            <div className="support-channel-card">
              <FaClipboardList />
              <h3>فورم التواصل</h3>
              <Link to="/contact">إرسال طلب من الموقع</Link>
            </div>
          </div>

          <div className="support-note">
            <FaClock />
            <span>
              يتم استقبال الاستفسارات والشكاوى على مدار الساعة، ويتم الرد خلال
              مدة أقصاها 24 ساعة من وقت استلام الطلب.
            </span>
          </div>

          <div className="support-actions">
            <a
              href={`https://wa.me/966920033239?text=${whatsappMessage}`}
              target="_blank"
              rel="noopener noreferrer"
              className="support-whatsapp-btn"
            >
              <FaWhatsapp />
              تواصل عبر واتساب
            </a>

            <Link to="/contact" className="support-form-btn">
              الذهاب لفورم التواصل
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}